// DO NOT EDIT MANUALLY
// This file was automatically generated by `scripts/MapboxStyles/process.ts`

import { MapboxStyleLayer } from '../types'

export const mapboxStyleGroupLayers_atlas_bikelane_presence: MapboxStyleLayer[] = [
  {
    layout: {
      'line-cap': 'round',
    },
    type: 'line',
    id: 'hitarea-bikelane-presence',
    paint: {
      'line-width': ['interpolate', ['linear'], ['zoom'], 8, 1, 16, 14],
      'line-opacity': 0,
      'line-color': '#d814ff',
    },
    filter: ['any', ['has', 'bikelane_left'], ['has', 'bikelane_right'], ['has', 'bikelane_self']],
  },
  {
    filter: ['has', 'bikelane_right'],
    type: 'line',
    id: 'bikelane_right',
    paint: {
      'line-color': [
        'case',
        ['match', ['get', 'bikelane_right'], ['missing'], true, false],
        '#fa80f4',
        ['match', ['get', 'bikelane_right'], ['not_expected'], true, false],
        'rgba(234, 200, 210, 0.68)',
        ['match', ['get', 'bikelane_right'], ['assumed_no'], true, false],
        'rgba(251, 172, 196, 0.69)',
        ['match', ['get', 'bikelane_right'], ['data_no'], true, false],
        'rgba(108, 124, 147, 0.67)',
        ['has', 'bikelane_right'],
        'rgba(142, 177, 240, 0.7)',
        'rgba(0, 0, 0, 0.7)',
      ],
      'line-offset': ['step', ['zoom'], 1, 14, 4, 16, 8],
      'line-width': [
        'interpolate',
        ['linear'],
        ['zoom'],
        8,
        1,
        16,
        ['match', ['get', 'bikelane_right'], ['missing'], 8, 4],
      ],
      'line-opacity': [
        'interpolate',
        ['linear'],
        ['zoom'],
        11,
        ['match', ['get', 'bikelane_right'], ['missing'], 0.7, 0],
        12,
        0.7,
      ],
    },
  },
  {
    filter: ['has', 'bikelane_self'],
    type: 'line',
    id: 'bikelane_self',
    paint: {
      'line-color': [
        'case',
        ['match', ['get', 'bikelane_self'], ['missing'], true, false],
        '#fa80f4',
        ['match', ['get', 'bikelane_self'], ['not_expected'], true, false],
        'rgba(234, 200, 210, 0.68)',
        ['match', ['get', 'bikelane_self'], ['assumed_no'], true, false],
        'rgba(251, 172, 196, 0.65)',
        ['match', ['get', 'bikelane_self'], ['data_no'], true, false],
        'rgba(108, 124, 147, 0.67)',
        ['has', 'bikelane_self'],
        'rgba(142, 177, 240, 0.7)',
        'rgba(0, 0, 0, 0.7)',
      ],
      'line-width': [
        'interpolate',
        ['linear'],
        ['zoom'],
        8,
        1,
        16,
        ['match', ['get', 'bikelane_self'], ['missing'], 8, 4],
      ],
      'line-opacity': [
        'interpolate',
        ['linear'],
        ['zoom'],
        11,
        ['match', ['get', 'bikelane_self'], ['missing'], 0.7, 0],
        12,
        0.7,
      ],
    },
  },
  {
    filter: ['has', 'bikelane_left'],
    type: 'line',
    id: 'bikelane_left',
    paint: {
      'line-color': [
        'case',
        ['match', ['get', 'bikelane_left'], ['missing'], true, false],
        '#fa80f4',
        ['match', ['get', 'bikelane_left'], ['not_expected'], true, false],
        'rgba(234, 200, 210, 0.68)',
        ['match', ['get', 'bikelane_left'], ['assumed_no'], true, false],
        'rgba(251, 172, 196, 0.68)',
        ['match', ['get', 'bikelane_left'], ['data_no'], true, false],
        'rgba(108, 124, 147, 0.67)',
        ['has', 'bikelane_left'],
        'rgba(142, 177, 240, 0.7)',
        'rgba(0, 0, 0, 0.7)',
      ],
      'line-offset': ['step', ['zoom'], -1, 14, -4, 16, -8],
      'line-width': [
        'interpolate',
        ['linear'],
        ['zoom'],
        8,
        1,
        16,
        ['match', ['get', 'bikelane_left'], ['missing'], 8, 4],
      ],
      'line-opacity': [
        'interpolate',
        ['linear'],
        ['zoom'],
        11,
        ['match', ['get', 'bikelane_left'], ['missing'], 0.7, 0],
        12,
        0.7,
      ],
    },
  },
  {
    type: 'symbol',
    id: 'left-right-indication-arrow',
    paint: {
      'icon-opacity': [
        'interpolate',
        ['linear'],
        ['zoom'],
        0,
        0,
        13,
        0,
        14,
        [
          'case',
          ['match', ['get', 'bikelane_self'], ['missing'], true, false],
          1,
          [
            'any',
            ['match', ['get', 'bikelane_left'], ['missing'], true, false],
            ['match', ['get', 'bikelane_right'], ['missing'], true, false],
          ],
          1,
          0.4,
        ],
      ],
    },
    layout: {
      'symbol-placement': 'line',
      'icon-image': 'chevron-double-right',
      'symbol-spacing': 100,
      'symbol-avoid-edges': true,
      'icon-padding': 0,
      'icon-allow-overlap': true,
      'icon-size': [
        'case',
        ['match', ['get', 'bikelane_self'], ['missing'], true, false],
        0.8,
        [
          'any',
          ['match', ['get', 'bikelane_left'], ['missing'], true, false],
          ['match', ['get', 'bikelane_right'], ['missing'], true, false],
        ],
        0.8,
        0.5,
      ],
    },
  },
]
